import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import debounce from 'lodash/debounce';
import { useStore } from 'hooks';
import { getFormattedSelectedConstants } from 'utils';
import { FiasTypes } from '../../../../constants';
import { FiasSearchProps } from '../../../../types';
import { Wrapper, SearchIcon, SearchInput } from './control.styled';

type ControlProps = {
  openMenu: boolean;
  setMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
  openPortal: () => void;
  closePortal: () => void;
} & Pick<FiasSearchProps, 'withSectors' | 'isDisabled'>;

export const Control: FC<ControlProps> = observer(
  ({
    openMenu,
    setMenuOpen,
    openPortal,
    closePortal,
    withSectors,
    isDisabled,
  }) => {
    const { fias } = useStore();
    const [placeholder, setPlaceholder] = useState<string>('');
    const [prevInputValue, setPrevInputValue] = useState<string>('');

    useEffect(() => {
      setPlaceholder(
        !openMenu
          ? 'Выберите ' +
              getFormattedSelectedConstants(
                [fias.currentFiasSearchType],
                FiasTypes
              )[0].label.toLowerCase()
          : fias.currentFiasSearchType === 'houses'
          ? 'Найти улицу'
          : 'Найти группу'
      );
    }, [fias.currentFiasSearchType, openMenu]);

    useEffect(() => {
      if (
        fias.currentValueSearch.length >= 3 &&
        fias.currentFiasSearchType === 'houses'
      ) {
        // Во избежание лишних запросов.
        // В случаях, если найденный элемент единственный и это объект с домами, дальнейшие запросы прекращаются при вводе дополнительных символов.
        // Если символы удаляются, то срабатывает false по prevInputValue и поиск продолжается.
        debouncedSearch();
      }

      if (fias.currentValueSearch.length < 3) {
        fias.clearSearchTree();
      }

      setPrevInputValue(fias.currentValueSearch);
      fias.setShowSecondOptionsField(false);

      return () => debouncedSearch.cancel();
    }, [fias.currentValueSearch]);

    const debouncedSearch = debounce(() => {
      if (
        fias.searchTree.length === 1 &&
        fias.searchTree[0].houses &&
        fias.currentValueSearch.length > prevInputValue.length
      ) {
        return;
      }

      if (withSectors) {
        fias.getSearchTreeWithSectors({ query: fias.currentValueSearch });
      } else {
        fias.getSearchTree({ query: fias.currentValueSearch });
      }
    }, 250);

    const openDropdown = () => {
      if (isDisabled) {
        return;
      }

      setMenuOpen(true);
      openPortal();
    };

    return (
      <Wrapper>
        <SearchIcon onClick={openDropdown} />
        <SearchInput
          type={'text'}
          placeholder={placeholder}
          onClick={openDropdown}
          value={fias.currentValueSearch}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            fias.setCurrentValueSearch(e.target.value);
          }}
          autoCorrect={'off'}
          spellCheck={'false'}
          autoComplete="new-password"
        />
        {/*<ChevronIcon isOpen={openMenu} onClick={toggleDropdown} />*/}
      </Wrapper>
    );
  }
);
